import styled, { css } from 'styled-components'
import { FlexContainer } from '../../styled'

export const ProfileContainer = styled(FlexContainer)`
  position: relative;

  > button:first-child {
    overflow: hidden;
    display: flex;
    align-items: center;
    min-width: 200px;
    height: 64px;
    justify-content: center;
    padding: 0;
    background: ${({ active, theme }) =>
    active ? theme.navbar.active.background : 'transparent'};
    color: ${({ theme }) => theme.navbar.text};
    border: none;
    outline: none;
    cursor: pointer;
    font-weight: ${({ theme }) => theme.navbar.fontWeight};

    &:focus {
      background: ${({ theme }) => theme.navbar.hover.background};
      color: ${({ theme }) => theme.navbar.hover.text};

      &svg {
        color: ${({ theme }) => theme.navbar.hover.text};
      }
    }

    &:hover {
      background: ${({ theme }) => theme.navbar.hover.background};
      color: ${({ theme }) => theme.navbar.hover.text};

      &svg {
        color: ${({ theme }) => theme.navbar.hover.text};
      }
    }
  }

  div.info {
    display: flex;
    flex-flow: column;
    margin: 0 13px 0 10px;

    p {
      font-size: 14px;
      text-transform: none;
      display: flex;
      align-items: center;

      & + p {
        font-size: 12px;
        font-weight: ${({ theme }) => theme.navbar.fontWeight};
      }
    }
  }

  .status {
    display: block;
    border-radius: 50%;
    margin-right: 5px;
    width: 6px;
    height: 6px;

    &.online {
      background-color: ${(props) => props.theme.online};
    }

    &.pause {
      margin-right: 8px;
      background-color: ${(props) => props.theme.pause};
    }

    &.offline {
      margin-right: 8px;
      background-color: ${(props) => props.theme.offline};
    }

    &.unavailable {
      background-color: ${(props) => props.theme.pause};
    }

    &.available {
      background-color: ${(props) => props.theme.primary};
    }
  }

  svg {
    width: 11px;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  grid-gap: 10px;
`
export const MenuContainer = styled(FlexContainer)`
  align-items: center;
  display: flex;
  /* Menu switcher */

  input {
    display: none;
  }

  input#menuSwitcher:checked + .menu-container {
    transform: translateY(0px) !important;
    opacity: 1 !important;
    pointer-events: initial !important;
  }

  input#filterSwitcher:checked {

  }

  .menu-container {
    display: flex;
    align-items: center;
    @media screen and (max-width: 1200px) {
      position: absolute;
      top: 100%;
      right: -1px;
      left: -1px;
      flex-flow: column;
      background-color: ${({ theme }) => theme.navbar.background};
      opacity: 0;
      padding: 1rem;
      display: flex;
      flex-flow: column-reverse nowrap;
      transform: translateY(calc(-100% - 64px));
      pointer-events: none;
      transition: transform 0.5s, opacity 0.5s;
      ul {
        border-right: none;
        flex-flow: column nowrap;
        height: fit-content;
      }

      > div {
        align-self: stretch;
        padding: 0 20px; /* TODO Remove hard coded pixel value */

        > button {
          width: 100%;
        }
      }
    }
  }

  label {
    display: none;
    cursor: pointer;
    color: white;
    @media screen and (max-width: 1200px) {
      display: initial;
    }

    svg {
      height: 54px;
      width: 54px;
      padding: 0.95rem;
    }
  }
`

export const DialogImage = styled.div`
  display: flex;
  align-items: center;

  > button {
    margin-top: 1rem;
    border: 1px solid #ec3ea2;
    color: #ec3ea2;
    height: fit-content;
    width: fit-content;
    border-radius: 20px;
    padding: 0 1.5rem;

    &:hover {
      background-color: #ec3ea2;
      color: ${({ theme }) => theme.navbar.background};
    }
  }

  > div {
    width: 10rem;
    height: 10rem;

    > img {
      width: 10rem;
      height: 10rem;
      line-height: 10rem;
    }
  }
`

export const DialogContent = styled.div`
  width: 100%;
  justify-content: center;
  color: ${({ theme }) => theme.primaryText};

  > div.content {
    display: flex;
    width: 100%;
    position: relative;
    justify-content: space-between;
    color: #000000;

    & + div {
      margin-top: 1rem;
    }

    &:last-child {
      margin-top: 2rem;
    }

    button:first-child {
      border: ${({ theme }) => `1px solid ${theme.primaryText}`};
      color: ${({ theme }) => theme.primaryText};
      background: ${({ theme }) => theme.primary};
      margin-right: 20px;
      cursor: not-allowed;
    }

    button {
      height: 35px;
      width: 130px;
      cursor: pointer;
      border: 1px solid transparent;
      color: ${({ theme }) => theme.primary};
      background: ${({ theme }) => theme.primaryText};
      font-weight: ${({ theme }) => theme.navbar.fontWeight};
      border-radius: ${({ theme }) => theme.button.primary.borderRadius};
    }
  }

  p {
    font-size: 1rem;

    p:first-child {
      font-size: 1.3rem;
      text-transform: capitalize;
      font-weight: bold;

      + label {
        position: absolute;
        top: -14px;
        right: 0;
      }
    }
  }
`

export const DialogSubtitle = styled.div``
export const DialogTitle = styled.div`
  color: ${({ primaryText, theme }) =>
    primaryText ? theme.primaryText : theme.container.secondary.title};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;

  span {
    font-size: 1.25rem;
    font-weight: bold;
    color: inherit;
    line-height: 1.6;
  }

  svg {
    color: ${({ primaryText, theme }) =>
    primaryText ? theme.primaryText : theme.container.secondary.title};
    height: 14px;
    cursor: pointer;
    border-radius: 50%;
  }
`

export const DialogContainer = styled.div`
  ${(props) =>
    props.pause
      ? css`
                    width: 400px;
                    max-width: 100%;
                    padding-top: 30px;
                    color: ${props.theme.container.secondary.text};
                    display: flex;
                    flex-wrap: wrap;
                    grid-gap: 6px;
                  `
      : props.appearance
        ? css`
                            width: 400px;
                            max-width: 100%;
                            padding-top: 30px;
                            color: ${props.theme.container.secondary.text};
                          `
        : props.distribuition
          ? css`
                                    display: flex;
                                    flex-direction: column;

                                    > button {
                                      align-self: flex-end;
                                      color: #ffffff;
                                      margin-top: 14px;
                                    }

                                    > div {
                                      display: flex;
                                      flex-direction: column;
                                      margin-top: 12px;

                                      > div {
                                        display: flex;
                                        justify-content: space-between;
                                        flex-direction: row;
                                      }
                                    }
                                  `
          : props.profile
            ? css`
                                            padding: 30px;
                                            display: flex;
                                            grid-gap: 32px;

                                            > div {
                                              display: flex;
                                              flex-flow: column;
                                            }
                                          `
            : ''}
`

export const Container = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  height: 64px;
  color: ${({ theme }) => theme.primaryText};
  background: ${({ theme }) => theme.navbar.background};

  > img {
    margin-left: 32px;
    width: auto;
    max-height: 27px;
    max-width: 106px;
  }

  z-index: 4;
  position: relative;
`

export const ActionOption = styled.div`
  position: absolute;
  width: 60%;
  padding: 10px 5px;
  margin-top: 60px;
  left: 20%;
  height: fit-content;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.container.secondary.background};
  box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-flow: column;
  z-index: 2;

  &.hidden {
    display: none;
  }

  > span {
    display: block;
    margin: 10px auto;
    background-color: #e0e0e0;
    height: 0.5px;
    width: 90%;
  }

  > a {
    width: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    outline: none;
    border: none;
    padding: 6px 0 6px 10px;
    text-transform: none;
    justify-content: flex-start;
    text-decoration: none;
    gap: 6px;
    background: transparent;
    color: ${({ theme }) => theme.container.secondary.text};
  }

  > button {
    width: 100%;
    font-size: 12px;
    display: flex;
    align-items: center;
    cursor: pointer;
    outline: none;
    border: none;
    padding: 6px 0 6px 10px;
    text-transform: none;
    justify-content: flex-start;
    background: transparent;
    color: ${({ theme }) => theme.container.secondary.text};

    &.logout {
      color: ${(props) => props.theme.offline};
    }

    svg {
      height: 10px;
      width: auto;
      margin-right: 8px;
      color: ${({ theme }) => theme.container.secondary.text};
      fill: ${({ theme }) => theme.container.secondary.text};
    }
  }

  &:before {
    background-color: ${({ theme }) =>
    theme.container.secondary.background};
    content: '';
    border-radius: 1px 3px 0 3px;
    display: block;
    width: 13px;
    height: 13px;
    margin: -15px auto 0 auto;
    transform: rotate(45deg);
  }
`

export const ContainerChange = styled.div`
  display: ${(props) => (props.className === 'current' ? 'block' : 'none')};

  > div + .password_form {
    > div {
      padding: 0;
      margin: 0;

      > form {
        width: 70%;
        margin: 0 auto;

        > div {
          margin-top: 20px;
          text-align: center;
          display: flex;
          justify-content: space-between;

          > button {
            border: 1px solid transparent;
            color: ${({ theme }) => theme.navbar.text};
            border-radius: 100px;
            min-height: unset;
            width: 45%;
            font-weight: bold;

            & + button {
              color: ${(props) => props.theme.primary};
              background-color: ${({ theme }) =>
    theme.navbar.background};
            }
          }
        }
      }
    }
  }
`

export const List = styled.ul`
  display: flex;
  border-right: ${({ theme }) => `1px solid ${theme.navbar.text}80`};
  padding: 0 20px;
  height: 64px;
  align-items: center;  

  &.onlyIcon {
    li:not(.dashboard) {
      &.dashboard-menu, > a {
          padding: 10px!important;
      }  
      svg {
        margin: 0;
      }
      p {
        display: none;
        & + svg {
          display: none;
        }
      }
          
    }
  }

  > li {
    padding: 0;
    display: flex;
    justify-content: center;
    border-radius: 5px;

    a {
      width: 100%;
      padding: 10px 16px;
      text-decoration: none;
      color: inherit;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        height: 16px;
        margin-right: 10px;
        color: inherit;
        width: auto;
      }

      p {
        color: inherit;
        white-space: nowrap;
        font-size: 0.75rem;
      }
    }
  }
`

export const Avatar = styled.div`
  width: 36px;
  height: 36px;
  margin-right: 7px;
  border-radius: 50%;
  color: #C099FF;
  background-color: #f7f2ff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin-top: 10px;
    height: 24px;
  }

  > img {
    width: 36px;
    height: 36px;
  }
`

export const SoftPhone = styled.iframe`
  height: 65px;
`


export const BlockedButton = styled.div`
  > button {
    color: #FFFFFF;
  }
`
export const BlockedSubtitle = styled.h4`
  margin-left: 5px;
  font-size: 1.5rem;
`
export const BlockedTitleContainer = styled.div`
  display: flex;
  align-items: flex-end;
`
export const BlockedTitle = styled.h1`
  font-size: 1.5rem;
`
export const BlockedTime = styled.div`
  font-weight: bold;
  font-size: 2rem;

  span {
    font-size: 1rem;
  }
`

export const Blur = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  backdrop-filter: blur(2px);
  background: rgba(36, 35, 38, 0.5);
`

export const BlockedPage = styled.div`
  width: 100%;
  height: fit-content;
  padding: 22px 0;
  background-color: #333333;
  display: flex;
  justify-content: center;
  overflow: hidden;
  align-items: center;
  color: #fff;
  grid-gap: 12px;

  &.not_blocked {
    > ${Blur} {
      display: none;
    }
  }

  &:not(.not_blocked) {
    height: 100%;
    z-index: 999;
    position: absolute;
    flex-direction: column;
    background-color: rgba(51, 51, 51, 0.95);
  }
`

